<template>
  <div class="print">
    <div class="contents">
      <div class="title">
        <span>{{ $t('관 리 감 독 자') }}<span class="mx-2"></span>{{ $t('지 정 서') }}</span>
      </div>

      <div class="userInfo">
        <p>{{ $t('소 속') }} : {{ form.inputC_2 }}</p>
        <p>{{ $t('직 책') }} : {{ form.inputC_3 }}</p>
        <p>{{ $t('성 명') }} : {{ form.inputC_1 }}</p>
      </div>

      <div class="message">
        <p class="mb-8">{{'&nbsp;'}}{{ $t('위 사람을 산업안전보건법 제16조 및 동법 시행령 제15조에 의거 아래와 같은 안전관리에 대한 업무를 수행할 수 있도록 당사의 관리감독자로 지정합니다.') }}</p>
        <p class="mt-8 text-center">{{ $t('《 관리감독자 직무 》') }}</p>
        <p>{{ $t('1. 사업장 내 관리감독자가 지휘ㆍ감독하는 작업과 관련된 기계ㆍ기구 또는 설비의 안전ㆍ보건 점검 및 이상 유무의 확인') }}</p>
        <p>{{ $t('2. 관리감독자에게 소속된 근로자의 작업복ㆍ보호구 및 방호장치의 점검과 그 착용ㆍ사용에관한 교육ㆍ지도') }}</p>
        <p>{{ $t('3. 해당작업에서 발생한 산업재해에 관한 보고 및 이에 대한 응급조치') }}</p>
        <p>{{ $t('4. 해당작업의 사업장 정리ㆍ정돈 및 통로 확보에 대한 확인ㆍ감독') }}</p>
        <p>{{ $t('5. 사업장의 다음 각 목의 어느 하나에 해당하는 사람의 지도ㆍ조언에 대한 협조') }}</p>
        <p class="sub">{{ $t('가. 안전관리자') }}</p>
        <p class="sub">{{ $t('나. 보건관리자') }}</p>
        <p class="sub">{{ $t('다. 안전보건관리담당자') }}</p>
        <p>{{ $t('6. 사업장의 다음 각 목의 어느 하나에 해당하는 사람의 지도ㆍ조언에 대한 협조') }}</p>
        <p class="sub">{{ $t('가. 유해ㆍ위험요인의 파악에 대한 참여') }}</p>
        <p class="sub">{{ $t('나. 개선조치의 시행에 대한 참여') }}</p>
        <p>{{ $t('7. 그 밖에 해당작업의 안전 및 보건에 관한 사항으로서 고용노동부령으로 정하는 사항') }}</p>
      </div>

      <div class="sign">
        <div class="yyyyMMdd p-2">
          <span class="year pr-6">{{ new Date(form.inputC_5).format("yyyy") }} {{ $t('년') }}</span>
          <span class="month pr-6">{{ new Date(form.inputC_5).format("MM") }} {{ $t('월') }}</span>
          <span class="day">{{ new Date(form.inputC_5).format("dd") }} {{ $t('일') }}</span>
        </div>

        <div class="body">{{ form.inputC_0 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Print297",
  props: {
    border: Object,
    form: Object,
  },
};
</script>

<style lang="scss" scoped>
.print {
  padding: 2rem 1rem;

  & > .contents {
    display: grid !important;
    width: 100%;
    height: auto;

    border: 1px solid #cdcdcd;

    padding: 1.5rem;
  }
}
.title {
  padding-top: 2rem;
  padding-bottom: 2rem;
  margin-bottom: 2rem;

  display: grid;
  align-items: center;
  justify-content: center;

  font-size: 3rem;
  font-weight: bold;
}

.userInfo {
  display: grid;
  justify-content: flex-end;
  margin-bottom: 1rem;

  & > p {
    width: 400px;

    font-size: 1.5rem;
    font-weight: 500;

    padding: 0.5rem 0;
    margin-bottom: 0.5rem;
  }
}

.message {
  p {
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 3.125rem;

    &.sub {
      padding-left: 1.5rem;
      font-size: 1.375rem;
      font-weight: 400 !important;
      line-height: 2.875rem;
    }
  }
}

.sign {
  padding-top: 60px;

  display: grid;
  justify-content: center;

  .yyyyMMdd {
    display: flex;
    justify-content: center;
    font-size: 1.6875rem;

    margin-bottom: 4rem;
  }

  .body {
    font-size: 48px;
    font-weight: 700;
    color: #3c3c3c;
    text-align: center;
    line-height: 2.75rem;
    margin-bottom: 60px;
  }

  .etc {
    margin-top: 2rem;
    text-align: center;

    font-size: 1.125rem;
    color: #3c3c3c;
    line-height: 2rem;
    text-decoration: underline;
  }
}
</style>
